import { lazy } from "react";
import paths from "../paths";

const Cancellation = lazy(() =>
  import("pages/cancellation").then(module => ({ default: module.Cancellation }))
);
const ConnectStore = lazy(() => import("pages/ConnectStore"));

export const accountRoutes = [
  { path: paths.account.downgrade, Component: Cancellation, app: true },
  { path: paths.account.connect, Component: ConnectStore, app: true }
];
